/**
 * Fetches Lagoon data from CDN fallback URL
 */
export const fetchLagoonFallbackData = async (url) => {
  if (!url) throw new Error('Fallback URL missing');
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Fallback request failed: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching Lagoon fallback data:', error);
    throw error;
  }
};

const normalizeToArray = (value) => {
  if (Array.isArray(value)) return value;
  if (value) return Object.values(value);
  return [];
};

/**
 * Supports both:
 * - fully qualified keys: namespace.table-name
 * - unqualified keys only - table-name
 *
 * Execution order:
 * 1. exact tablename
 * 2. if fully qualified & missing -> try unqualified
 * 3. if unqualified & missing -> try namespace.table-name
 */
export const createLagoonFallbackInterface = (
  fallbackData = {},
  namespace
) => ({
  getTable: (tableName) => {
    let raw = fallbackData[tableName];

    const isQualified = tableName.includes('.') && namespace;

    // If fully qualified but not found, try dropping the namespace prefix
    if (!raw && isQualified && tableName.startsWith(`${namespace}.`)) {
      raw = fallbackData[tableName.slice(namespace.length + 1)];
    }

    // If unqualified but not found, try adding namespace prefix
    if (!raw && namespace && !tableName.includes('.')) {
      raw = fallbackData[`${namespace}.${tableName}`];
    }
    const arr = normalizeToArray(raw);
    return {
      getRow: (rowKey) => {
        if (!rowKey) return arr;
        return arr.find((r) => r?.id === rowKey || r?.key === rowKey);
      },
    };
  },
});
